import React from 'react';

const MenuContext = React.createContext({});

export default MenuContext;

export function connect(Component) {
  function WrappedItem(props) {
    const { forwardedRef, ...other } = props;
    return (
      <MenuContext.Consumer>
        {store => {
          const { value, ...storeData } = store;
          return <Component {...storeData} {...other} currentValue={value} ref={forwardedRef} />;
        }}
      </MenuContext.Consumer>
    );
  }
  function forwardRef(props, ref) {
    return <WrappedItem {...props} forwardedRef={ref} />;
  }

  // Give this component a more helpful display name in DevTools.
  forwardRef.displayName = 'ConnectedMenuItem';
  return React.forwardRef(forwardRef);
}



// WEBPACK FOOTER //
// ./src/menu/MenuContext.jsx